import React from 'react';
import noop from 'lodash/noop';
import WarningIcon from '../icons/Warning.svg';
import AppContainer from '../AppContainer';
import Button from '../Button';
import { AVAILABLE_LATER, SERVING_OPTION } from '../../utils/constants';

export default ({
  pickupTimes,
  appStyles = {},
  onRetryClicked = noop,
  T,
  branch,
  isBranchNotAvailable,
  currentBranchOpeningTime,
  hasDelayedOrder,
  locationClosedMessage,
  selectedServingOptionType,
}) =>
  pickupTimes.error ? (
    <div style={{ padding: 10 }}>
      <div style={isBranchNotAvailable && { display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <WarningIcon style={{ marginRight: 6 }} />
        {isBranchNotAvailable ? `${branch} ${T('is not available.')}` : T('Connection Error :(')}
      </div>
      <AppContainer.CenteredColumn>
        {isBranchNotAvailable ? (
          <Button slim centered appStyles={appStyles} style={{ marginTop: 8 }} onClick={onRetryClicked}>
            {T('Please choose a different location')}
          </Button>
        ) : (
          <Button slim linkStyle appStyles={appStyles} style={{ marginTop: 8 }} onClick={onRetryClicked}>
            {T('Try Again')}
          </Button>
        )}
      </AppContainer.CenteredColumn>
    </div>
  ) : (
    <div style={{ width: '90%' }}>
      <WarningIcon style={{ marginRight: 6, display: 'inline' }} />
      <div style={{ display: 'inline' }}>
        {hasDelayedOrder ? `${locationClosedMessage}` : T('The location is currently closed for ordering')}
      </div>
      {!(
        selectedServingOptionType === SERVING_OPTION.CATERING ||
        selectedServingOptionType === SERVING_OPTION.CATERING_DELIVERY
      ) &&
        pickupTimes.status === AVAILABLE_LATER &&
        currentBranchOpeningTime && (
          <div style={{ marginTop: 6 }}>
            {hasDelayedOrder
              ? T('but you can still order for later')
              : `${T('Opens at - ')} ${currentBranchOpeningTime}`}
          </div>
        )}
    </div>
  );
